import { render, staticRenderFns } from "./FeeReminderPrint.vue?vue&type=template&id=8218f704&scoped=true&"
import script from "./FeeReminderPrint.vue?vue&type=script&lang=js&"
export * from "./FeeReminderPrint.vue?vue&type=script&lang=js&"
import style0 from "./FeeReminderPrint.vue?vue&type=style&index=0&id=8218f704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8218f704",
  null
  
)

export default component.exports